<template>
  <div class="phzblist">
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <div class="searchdiv">
        <div class="sitem">
          <menu class="active"><p>全部</p></menu>
          <menu class="no"><p>上架时间</p></menu>
          <menu class="no"><p>商品价格</p></menu>
        </div>
      </div>
      <div>
        <div class="contentdiv">
          <ul class="itemdiv">
            <template v-for="item in list">
              <li class="item" :key="item.id">
                <a href="javsscript:void(0)" @click="goGoodsInfo(item.id)" style="color:#323232;">
                  <dl>
                    <dt>
                      <img :src="item.firstPhoto" />
                    </dt>
                    <dd>
                      <p>{{ item.proName }}</p>
                      <p class="price">
                        ¥{{ item.price }}
                        <!-- <i class="iconfont">&#xe627;</i> -->
                      </p>
                    </dd>
                  </dl>
                </a>
              </li>
            </template>
          </ul>
          <div class="clear-both" style="height: 0rem;"></div>
        </div>
      </div>
    </van-pull-refresh>
  </div>
</template>

<script>
export default {
  name: 'phzbList',
  data() {
    return {
      count: 0,
      isLoading: false,
      list: [],
    }
  },
  created() {
    this.queryGoodsPage()
  },
  methods: {
    queryGoodsPage() {
      var that = this
      this.$queryPage('ProGoods', {channel:'rented'}, ['id', 'proName', 'firstPhoto', 'price'], function(res) {
        that.$fill(that.list, res['data'])
      })
    },
    goGoodsInfo(id){
      this.$router.push({ path: '/shop/detail/'+id })
    },
    onRefresh() {
      setTimeout(() => {
        this.isLoading = false
        this.count++
      }, 1000)
    },
  },
}
</script>

<style>
.phzblist .searchdiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}

.phzblist .searchdiv {
  padding: 0 1.5rem 0.2rem;
  background-color: #fff;
}
.phzblist .searchdiv .sitem {
  width: 100%;
  height: 4.6rem;
  box-sizing: border-box;
  background-color: #fff;
  border-bottom: 1px solid #eee;
  border-top: 1px solid #eee;
}
.phzblist .sitem .active {
  width: 33.3%;
  box-sizing: border-box;
  float: left;
  line-height: 2.3rem;
  font-size: 1.4rem;
}
.phzblist .sitem .active p {
  width: 100%;
  color: #15a892 !important;
}
.phzblist .sitem .no {
  width: 33.3%;
  box-sizing: border-box;
  float: left;
  line-height: 2.3rem;
  font-size: 1.4rem;
}
.phzblist .sitem .no p {
  width: 100%;
  color: #000;
}

.phzblist .contentdiv {
  padding: 0 1.2rem;
  background-color: #f3f3f3;
}
.phzblist .itemdiv {
  margin-top: 0.85rem;
}

.phzblist .contentdiv .itemdiv .item:nth-of-type(odd) {
  margin-right: 1rem;
}

.phzblist .contentdiv .itemdiv .item {
  float: left;
  width: calc(50% - 0.6rem);
  margin-bottom: 1rem;
  box-sizing: border-box;
  background-color: #fff;
}
.phzblist .contentdiv .itemdiv .item dl {
  width: 100%;
}
.phzblist .contentdiv .itemdiv .item dl dt img {
  width: 100%;
  max-height: 11.3rem;
  display: block;
}
.phzblist .contentdiv .itemdiv .item dl dd {
  padding: 0.6em 1.4rem;
  font-size: 1.4rem;
  line-height: 2rem;
}

.phzblist .clear-both {
  clear: both;
  height: 5rem;
  height: 0rem;
}
.phzblist .price {
  padding-top: 0.3rem;
  color: #15a892;
}
.phzblist .price i {
  float: right;
  position: relative;
  top: 0.2rem;
  display: block;
  color: #777;
}
</style>
